import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export interface ApiToken {
  id: string;
  name: string;
  tokenPrefix: string;
  /** Only present on the create response. Never returned by list. */
  token?: string;
  createdBy: string | null;
  createdAt: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
}

export function useApiTokens() {
  return useQuery({
    queryKey: ['api-tokens'],
    queryFn: async () => {
      const r = await api.get<{ tokens: ApiToken[] }>('/api/api-tokens');
      return r.data.tokens;
    },
  });
}

export function useCreateApiToken() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (name: string) => {
      const r = await api.post<ApiToken>('/api/api-tokens', { name });
      return r.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['api-tokens'] }),
  });
}

export function useRevokeApiToken() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/api/api-tokens/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['api-tokens'] }),
  });
}
